import React, { Component } from 'react';
import './ec2ExTitle.css';

class Ec2ExTitle extends Component {

  state = {
    inputHeader: 'hidden',
    inputOperator: 'Equals',
    inputFilter: ''
  }

  componentDidMount() {

  }

  render() {

    return (
      <div className="Ec2ExTitlePage">
        <h1>EC2 Reservation Explorer</h1>
        <button onClick={this.handleDownloadCsvClick}>Download CSV</button>
        <div>
          <div className="CurrentFilters">
            {this.props.filter.map((filter, index) => {
              return (
                <div key={filter.id} className="FilterRow">
                  <p>{filter.header} - {filter.operator} - {filter.filterVal}</p>
                  <button onClick={() => this.handleInvertFilter(index)}>Invert</button>
                  <button onClick={() => this.handleRemoveFilter(index)}>Remove</button>
                </div>
              );
            })}
          </div>
          <div className="FilterRow">
            <p>Filter:</p>
            <select id="inputHeader" value={this.state.inputHeader} onChange={this.handleInput}>
              {this.props.headers.filter(header => header.key).map(header => {
                return <option key={header.title} value={header.key}>{header.title}</option>;
              })}
              <option value="Title">Title</option>
            </select>
            <select id="inputOperator" value={this.state.inputOperator} onChange={this.handleInput}>
              <option value="Equals">Equals</option>
              <option value="Doesn't Equal">Doesn't Equal</option>
              <option value="Contains">Contains</option>
              <option value="Doesn't Contain">Doesn't Contain</option>
            </select>
            <input id="inputFilter" value={this.state.inputFilter} onChange={this.handleInput}/>
            <button onClick={this.submitFilter}>Filter</button>
          </div>
        </div>
      </div>
    );
  }

  handleInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  handleDownloadCsvClick = () => {
    this.props.downloadCsv();
  }

  submitFilter = () => {
    // this.props.addFilter([this.state.inputHeader, this.state.inputOperator, this.state.inputFilter]);
    this.props.addFilter({
      id: `filter${Date.now()}`,
      header: this.state.inputHeader,
      operator: this.state.inputOperator,
      filterVal: this.state.inputFilter
    });
  }

  handleRemoveFilter = index => {
    this.props.removeFilter(index);
  }

  handleInvertFilter = index => {
    this.props.invertFilter(index);
  }

}

export default Ec2ExTitle;


// WEBPACK FOOTER //
// ./src/components/content/ec2ResExplorer/ec2ExTitle/ec2ExTitle.js